import { PROJECT_DETAILS_ACTION, STATUS } from "../constant";

const initState = {
  projectData: []
};

export default function projectDetails(state = initState, action) {
  switch (action.type) {
    case PROJECT_DETAILS_ACTION.PROJECT_DETAILS_START:
      return {
        ...state,
        projectDetailsStatus: STATUS.LOADING,
        projectData: []
      };
    case PROJECT_DETAILS_ACTION.PROJECT_DETAILS_SUCCESS: {
      return {
        ...state,
        projectData: action.payload,
        projectDetailsStatus: STATUS.SUCCESS
      };
    }
    case PROJECT_DETAILS_ACTION.PROJECT_DETAILS_FAILURE:
      return { ...state, projectDetailsStatus: STATUS.ERROR };

    case PROJECT_DETAILS_ACTION.DRAFTED_PROJECT_DETAILS_START:
      return { ...state, draftedProjectDetailsStatus: STATUS.LOADING };
    case PROJECT_DETAILS_ACTION.DRAFTED_PROJECT_DETAILS_SUCCESS: {
      return {
        ...state,
        draftedProjectData: action.payload,
        draftedProjectDetailsStatus: STATUS.SUCCESS
      };
    }
    case PROJECT_DETAILS_ACTION.DRAFTED_PROJECT_DETAILS_FAILURE:
      return { ...state, draftedProjectDetailsStatus: STATUS.ERROR };
    case PROJECT_DETAILS_ACTION.PROJECT_TIMELINE_START:
      return { ...state, projectTimelineStatus: STATUS.LOADING };
    case PROJECT_DETAILS_ACTION.PROJECT_TIMELINE_SUCCESS: {
      return {
        ...state,
        projectTimelineData: action.payload,
        projectTimelineStatus: STATUS.SUCCESS
      };
    }
    case PROJECT_DETAILS_ACTION.PROJECT_TIMELINE_FAILURE:
      return { ...state, projectTimelineStatus: STATUS.ERROR };
    case PROJECT_DETAILS_ACTION.PROJECT_DECISION_DETAILS_START:
      return { ...state, projectAddDecisionStatus: STATUS.LOADING };
    case PROJECT_DETAILS_ACTION.PROJECT_DECISION_DETAILS_SUCCESS: {
      return {
        ...state,
        projectAddDecisionData: action.payload,
        projectAddDecisionStatus: STATUS.SUCCESS
      };
    }
    case PROJECT_DETAILS_ACTION.PROJECT_DECISION_DETAILS_FAILURE:
      return { ...state, projectAddDecisionStatus: STATUS.ERROR };

    case PROJECT_DETAILS_ACTION.PROJECT_MEETING_TYPES_START:
      return { ...state, projectAddDecisionMeeting: STATUS.LOADING };
    case PROJECT_DETAILS_ACTION.PROJECT_MEETING_TYPES_SUCCESS: {
      return {
        ...state,
        projectAddDecisionMeetingTypes: action.payload,
        projectAddDecisionMeetingStatus: STATUS.SUCCESS
      };
    }
    case PROJECT_DETAILS_ACTION.PROJECT_MEETING_TYPES_FAILURE:
    default:
      return state;

    case PROJECT_DETAILS_ACTION.PROJECT_MILESTONE_START:
      return {
        ...state,
        projectMilestoneStatus: STATUS.LOADING
      };
    case PROJECT_DETAILS_ACTION.PROJECT_MILESTONE_SUCCESSS:
      return {
        ...state,
        projectMilestoneData: action.payload,
        projectMilestoneStatus: STATUS.SUCCESS
      };
    case PROJECT_DETAILS_ACTION.PROJECT_MILESTONE_FAILURE:
      return {
        ...state,
        projectMilestoneStatus: STATUS.ERROR
      };
  }
}
